import styled from 'styled-components'
import React from 'react'
// --> ASSETS
import { colors } from '../../theme'
import logoEmpresa from '../../assets/images/logo-empresa.png'
import backgroundImage from '../../assets/images/background.png'
// --> COMPONENTS
import { Link } from 'react-router-dom'
import { Button } from '../../components'
// --> MEDIAS
import { sm } from '../../consts/medias'
import { Form } from 'components/CoForm'

const Logo = (props) => <img {...props} src={logoEmpresa} alt="Logo Savane" />

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa, #e4e7ec);
`

const ImageSide = styled.div`
  flex: 1;

  background-image: url(${backgroundImage});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;

  @media ${sm} {
    display: none;
  }
`

const HocLink = ({ className, ...props }) => (
  <div className={className}>
    <Link {...props} />
  </div>
)

const StyledLink = styled(HocLink)`
  font-size: 13px;
  margin-top: 8px;

  a {
    color: ${colors.colorAppBar};
    text-decoration: none;
    transition: 0.2s;

    &:hover {
      text-decoration: underline;
      opacity: 0.8;
    }
  }
`

const StyledForm = styled(Form)`
  flex: 1;
  max-width: 540px;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 0 auto;
  padding: 48px;

  background-color: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(10px);

  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

  position: relative;

  .subtitle {
    text-align: center;
    line-height: 150%;
    margin-top: 8px;
  }

  .subtitle,
  > footer small {
    color: ${colors.color300};
    font-size: 13px;
    font-weight: 300;
    letter-spacing: 0.3px;
  }

  > main {
    width: 100%;
    max-width: 420px;

    header {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 32px;

      img {
        margin-bottom: 16px;
        max-width: 180px;
      }

      h1 {
        font-size: 20px;
        font-weight: 600;
        color: ${colors.color900};
      }
    }

    .fields {
      display: flex;
      flex-direction: column;
      margin: 12px 0;

      label {
        font-size: 13px;
        margin-bottom: 4px;
        color: ${colors.color700};
      }

      .MuiFilledInput-root,
      .MuiInputBase-input:-webkit-autofill {
        background-color: transparent !important;
      }

      .MuiFormControl-root,
      .MuiAutocomplete-root {
        flex: 1 1 auto;
        margin: 10px 0;
      }

      .MuiOutlinedInput-root {
        border-radius: 10px;
      }

      .MuiButton-container-root {
        margin-top: 12px;
        display: flex;
      }

      .hidden {
        display: none;
      }
    }

    .links {
      margin-top: 8px;

      ${StyledLink} {
        &:nth-child(2) {
          margin-top: 4px;
        }
      }
    }
  }

  footer {
    position: absolute;
    bottom: 12px;

    display: flex;
    justify-content: center;
    width: 100%;
  }

  @media ${sm} {
    max-width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
    padding: 24px;

    .subtitle,
    footer {
      display: none;
    }

    > main {
      max-width: 100%;

      header img {
        margin-bottom: 24px;
      }
    }
  }
`

const SubmitButton = styled(Button)`
  width: 100%;
  height: 45px;
  border-radius: 8px;
  margin: 12px auto;
  color: white;
  background-color: ${colors.colorAppBar};

  &:hover {
    background-color: ${colors.colorAppBar};
  }

  span {
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
  }
`

const PasswordControl = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span.MuiTypography-root,
  a {
    font-size: 13px;
  }

  .MuiSvgIcon-root {
    width: 0.85em;
    height: 0.85em;
  }
`

export {
  Container,
  ImageSide,
  StyledForm,
  SubmitButton,
  PasswordControl,
  StyledLink,
  Logo,
}
